import { call, put, takeLatest } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"

import {
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  GET_DIVISION_WATCHER,
  GET_DIVISION_PARENTS_WATCHER,
  GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER,
  DELETE_DIVISION_WATCHER,
  ADD_SUBDIVISION_WATCHER,
  GET_CHILDREN_DIVISION_WATCHER,
  DELETE_SUBDIVISION_WATCHER,
  UPDATE_NAME_DIVISION_WATCHER,
  CHANGE_SELECT_SUPERIOR_WATCHER,
  UP_LEVEL_ONE_WATCHER,
  GET_COLLABORATORS_DIVISION_WATCHER,
  GET_HISTORY_WATCHER,
  GET_LANGUAGE_WATCHER,
} from "./constants"
import {
  getEmployeesDivisionsFailed,
  getEmployeesDivisionsSuccess,
  getDivisionWatcher,
  getDivisionSuccess,
  getDivisionFailed,
  getDivisionParentsSuccess,
  getSubdivisionsWithoutParentSuccess,
  getChildrenDivisionSuccess,
  getChildrenDivisionFailed,
  getCollaboratorsDivisionSuccess,
  deleteDivisionFailed,
  updateNameDivisionFailed,
  deleteSubdivisionSuccess,
  deleteSubdivisionFailed,
  addSubdivisionFailed,
  getHistoryWatcher,
  getHistorySuccess,
  getLanguageSuccess,
  getLanguageFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

// GET LANGUAGE
export function getLanguageApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}language/`,
  })
}
export function* getLanguageSaga() {
  try {
    const {
      data: { data },
    } = yield call(getLanguageApi)

    yield put(getLanguageSuccess(data))
  } catch (error) {
    yield put(getLanguageFailed())
    returnMessage(error)
  }
}

export function getEmployeesDivisionsApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}ambassadors/create`,
  })
}

// GET DIVISION
function getDivisionApi(id) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${id}?relation=divisionparents`,
  })
}

export function* getDivisionSaga(action) {
  try {
    const { data, status } = yield call(getDivisionApi, action.payload)

    if (status === 200) {
      yield put(getDivisionSuccess(data.data))
    }
  } catch (error) {
    yield put(getDivisionFailed())
    returnMessage(error)
  }
}

// GET DIVISION CHILDREN
function getDivisionChildrenApi(id) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${id}?relation=divisionchildren`,
  })
}

export function* getDivisionChildren(action) {
  try {
    const { data } = yield call(getDivisionChildrenApi, action.payload)

    yield put(getChildrenDivisionSuccess(data.data))
  } catch (error) {
    yield put(getChildrenDivisionFailed())
    returnMessage(error)
  }
}

// GET DIVISION PARENTS
function getDivisionParentsApi(id) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${id}/potential/parentdivision`,
  })
}

export function* getDivisionParents(action) {
  try {
    const { data } = yield call(getDivisionParentsApi, action.payload)

    yield put(getDivisionParentsSuccess(data.data))
  } catch (error) {}
}

// GET DIVISION WITHOUT PARENT
export function getSubdivisionsWithoutParentApi(idDivision) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/potential/subdivision`,
  })
}

export function* getSubdivisionsWithoutParent(action) {
  try {
    const { data } = yield call(getSubdivisionsWithoutParentApi, action.payload)

    yield put(getSubdivisionsWithoutParentSuccess(data.data))
  } catch (error) {}
}

// ADD SUBDIVISION
export function addSubdivisionApi({ idDivision, idSubdivision }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/subdivision/`,
    data: { id_division: idSubdivision },
  })
}

export function* addSubdivision(action) {
  try {
    const { status, data } = yield call(addSubdivisionApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idDivision }

      yield put(getHistoryWatcher(action.payload.idDivision))
      yield call(getDivisionParents, params)
      yield call(getDivisionChildren, params)
      yield call(getSubdivisionsWithoutParent, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (e) {
    yield put(addSubdivisionFailed())
    returnMessage(e)
  }
}

// DELETE DIVISION
export function deleteDivisionApi(id) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${id}`,
  })
}

export function* deleteDivision(action) {
  try {
    const { data, status } = yield call(deleteDivisionApi, action.payload)

    if (status === 200) {
      yield call(messageSuccess, data.data.msj)
      yield put(push("/organization/divisions"))
    }
  } catch (e) {
    yield put(deleteDivisionFailed())
    returnMessage(e)
  }
}

// DELETE SUBDIVISION
export function deleteSubdivisionApi({ idDivision, idSubdivision }) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/subdivision/${idSubdivision}`,
  })
}

export function* deleteSubdivision(action) {
  try {
    const { data, status } = yield call(deleteSubdivisionApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idDivision }

      yield put(getHistoryWatcher(action.payload.idDivision))
      yield call(getDivisionChildren, params)
      yield call(getSubdivisionsWithoutParent, params)
      yield put(deleteSubdivisionSuccess(data.data))
      // yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield put(deleteSubdivisionFailed(""))
    returnMessage(error)
  }
}

// UPDATE NAME DIVISION
export function updateNameDivisionApi({ idDivision, nameDivision }) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}`,
    data: { name: nameDivision }

  })
}

export function* updateNameDivision(action) {
  try {
    const { data, status } = yield call(updateNameDivisionApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idDivision }
      yield put(getHistoryWatcher(action.payload.idDivision))
      yield call(getDivisionSaga, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    const {
      response: { data },
    } = error

    if (data.line) {
      yield call(messageFailed, "Error al cambiar el nombre")
    }

    if (data.data.error.name) {
      yield put(updateNameDivisionFailed(data.data.code))
      yield call(messageFailed, data.data.error.name[0])
    } else if (data.data.error) {
      yield put(updateNameDivisionFailed(data.data.code))
      yield call(messageFailed, data.data.error)
    }
  }
}

// UPDATE SELECT SUPERIOR
export function changeSelectSuperiorApi({ idDivision, idParent }) {
  const idParentSinAsignar = idParent === "sin-asignar" ? "" : idParent
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/parentdivision`,
    data : { id_parent: idParentSinAsignar }
  })
}

export function* changeSelectSuperior(action) {
  try {
    const { data, status } = yield call(changeSelectSuperiorApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idDivision }

      yield put(getHistoryWatcher(action.payload.idDivision))
      yield put(getDivisionWatcher(params.payload))
      yield call(getSubdivisionsWithoutParent, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield call(messageFailed, "Error al cambiar la división superior")
  }
}

// GO UP LEVEL ONE
export function upLevelOneApi(idDivision) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/level/first`,
  })
}

export function* upLevelOne(action) {
  try {
    const { data, status } = yield call(upLevelOneApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload }
      yield put(getDivisionWatcher(params.payload))
      yield call(getDivisionChildren, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    yield call(messageFailed, "Error al cambiar la división superior")
  }
}

// GET COLLABORATORS FOR DIVISION
export function getCollaboratorsDivisionApi(idDivision) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/${idDivision}/employees`,
  })
}

export function* getCollaboratorsDivision(action) {
  try {
    const { data, status } = yield call(
      getCollaboratorsDivisionApi,
      action.payload
    )

    if (status === 200) {
      yield put(getCollaboratorsDivisionSuccess(data))
    }
  } catch (error) {
    yield call(messageFailed, "Error al cargar colaboradores")
  }
}

export function* getEmployeesDivisionsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(getEmployeesDivisionsApi, params)
    const result = {
      employees: data.data.data.result.employees,
      divisions: data.data.data.result.divisions,
    }

    yield put(getEmployeesDivisionsSuccess(result))
  } catch (error) {
    yield put(getEmployeesDivisionsFailed())
    returnMessage(error)
  }
}

export function* getHistorySaga(action) {
  try {
    const {
      data: {
        data: { result },
      },
    } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `divisions/${action.payload}/logs`,
    })

    yield put(getHistorySuccess(result.logs))
  } catch (error) {
    returnMessage(error)
  }
}

export default function* getDivisionWatcherSaga() {
  yield takeLatest(GET_DIVISION_WATCHER, getDivisionSaga)
  yield takeLatest(GET_CHILDREN_DIVISION_WATCHER, getDivisionChildren)
  yield takeLatest(GET_DIVISION_PARENTS_WATCHER, getDivisionParents)
  yield takeLatest(
    GET_SUBDIVISIONS_WIHOUT_PARENT_WATCHER,
    getSubdivisionsWithoutParent
  )
  yield takeLatest(DELETE_DIVISION_WATCHER, deleteDivision)
  yield takeLatest(ADD_SUBDIVISION_WATCHER, addSubdivision)
  yield takeLatest(DELETE_SUBDIVISION_WATCHER, deleteSubdivision)
  yield takeLatest(UPDATE_NAME_DIVISION_WATCHER, updateNameDivision)
  yield takeLatest(CHANGE_SELECT_SUPERIOR_WATCHER, changeSelectSuperior)
  yield takeLatest(UP_LEVEL_ONE_WATCHER, upLevelOne)
  yield takeLatest(GET_COLLABORATORS_DIVISION_WATCHER, getCollaboratorsDivision)
  yield takeLatest(GET_EMPLOYEES_DIVISIONS_WATCHER, getEmployeesDivisionsSaga)
  yield takeLatest(GET_HISTORY_WATCHER, getHistorySaga)
  yield takeLatest(GET_LANGUAGE_WATCHER, getLanguageSaga)
}
